import React, { ReactNode } from 'react';
import { TabsContextProvider } from './TabsContext';

interface IProps {
  children: ReactNode;
  onTabChange?: (tabIndex: number) => void;
}

const Tabs = ({ children, onTabChange }: IProps) => {
  return (
    <TabsContextProvider onTabChange={onTabChange}>
      {children}
    </TabsContextProvider>
  );
};

export default Tabs;
